<template>
  <div class="impersonation-banner d-flex align-items-center justify-content-between">
    <span>
      You are impersonating {{ affiliateEmail }} as {{ adminEmail }}.
    </span>
    <b-button size="sm" variant="light" @click="$emit('end')">
      End impersonation
    </b-button>
  </div>
</template>

<script>
export default {
  name: 'ImpersonationBanner',
  props: {
    adminEmail: {
      type: String,
      default: '',
    },
    affiliateEmail: {
      type: String,
      default: '',
    },
  },
};
</script>

<style scoped>
.impersonation-banner {
  background-color: #f2c94c;
  color: #1f2937;
  padding: 0.75rem 1rem;
  font-weight: 600;
}
</style>
